import { AngularServices } from '../../../../modules/core';
import { MediaModes } from '../../../../providers/video/abstract-video-provider';
import _ from 'lodash';
import { RootScopeEvents } from '../../root-scope-types';
import { PEOPLE_TYPES } from '../../../../store/features/realtime/presence';
import * as tracking from '../../../../modules/tracking';
export class StateWatcher {
    constructor($injector) {
        this.$injector = $injector;
        this.trackData = {
            userId: null,
            userType: null,
            sessionId: null,
            roomId: null,
            channel: null,
            mediaMode: null,
            noSoundDetected: false,
            callInitiator: null,
        };
        this.$rootScope = $injector.get('$rootScope');
        this.pn = $injector.get(AngularServices.Pn);
        const Browser = $injector.get('Browser');
        this.segmentContext = {
            ...this.segmentContext,
            ..._.pick(Browser.getSystemInfo(), ['browser', 'browserVersion', 'os', 'osversion', 'platform', 'tablet'], null),
        };
        this.$rootScope.$on('media-stream:no-sound', () => {
            if (this.trackData.noSoundDetected) {
                return;
            }
            this.trackData = {
                ...this.trackData,
                noSoundDetected: true,
            };
        });
        this.$rootScope.$on(RootScopeEvents.CHECK_IN_SUCCESS, () => {
            this.trackData = {
                ...this.trackData,
                userId: null,
                userType: this.pn.getUserType(),
                roomId: tracking.helpers.getContextRoomId(),
            };
        });
        this.$rootScope.$on('activeProvider:createSession:success', (_e, { sessionId, roomId, channel, mediaMode = MediaModes.RELAYED }) => {
            this.trackData = {
                ...this.trackData,
                noSoundDetected: false,
                sessionId,
                roomId,
                channel,
                mediaMode,
            };
        });
        this.$rootScope.$on('activeProvider:joinSession:success', (e, { sessionId, channel }) => {
            this.trackData = {
                ...this.trackData,
                noSoundDetected: false,
                sessionId,
                channel,
            };
        });
        this.$rootScope.$on(RootScopeEvents.PHONE.START, (e, data) => {
            this.trackData = {
                ...this.trackData,
                callInitiator: data.callInitiator,
            };
        });
    }
    // Stupid angular
    static getInstance($injector) {
        if (!StateWatcher.instance) {
            StateWatcher.instance = new StateWatcher($injector);
        }
        return StateWatcher.instance;
    }
    getSegmentContext() {
        return this.segmentContext;
    }
    getTrackData() {
        return this.trackData;
    }
    getSegmentTrackData() {
        return {
            ...this.trackData,
            ...this.getInstitutionInfo(),
            ...this.getUserInfo(),
        };
    }
    getUserInfo() {
        const currentUserHelper = this.$injector.get(AngularServices.CurrentUserHelper);
        if (!Boolean(currentUserHelper.user)) {
            return {
                userId: null,
                userType: PEOPLE_TYPES.patient,
            };
        }
        return {
            userId: currentUserHelper.user.id,
            userType: currentUserHelper.getUserType(),
            planType: currentUserHelper.getPlanType(),
        };
    }
    getInstitutionInfo() {
        const institutionHelper = this.$injector.get(AngularServices.InstitutionHelper);
        const currentInstitution = institutionHelper.currentInstitution;
        if (!Boolean(currentInstitution?.id)) {
            return {
                clinicId: null,
                domain: null,
            };
        }
        return {
            clinicId: currentInstitution.id,
            domain: _.get(institutionHelper, 'domain', null),
        };
    }
}
